import type { IconData } from '@stacksjs/iconify-core'

export const at: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M495.826 232a206.6 206.6 0 0 0-18.882-78.412a227 227 0 0 0-51.61-71.261C379.708 39.555 319.571 16 256 16A240 240 0 0 0 86.294 425.706a240 240 0 0 0 337.671 1.722l-22.4-22.856A206.82 206.82 0 0 1 256 464c-114.691 0-208-93.309-208-208S141.309 48 256 48c112.748 0 208 87.925 208 192v36c0 28.673-25.122 52-56 52s-56-23.327-56-52V160h-32v26.751a99.988 99.988 0 1 0 12.55 132.437C347.956 343.62 376.01 360 408 360c48.523 0 88-37.682 88-84v-44ZM252 328a68 68 0 1 1 68-68a68.077 68.077 0 0 1-68 68\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default at
